import { css } from '@linaria/core';
import { zIndexVars, easing, gridVars } from '../../cssVariables';
export const GlobalCssVariables = css `
	:global(html) {
		${zIndexVars}
		${easing}
		${gridVars}
	}
`;
